export const TOKEN_AUTH_CLIENT_ID = "{{authClientId}}";
export const TOKEN_EXCHANGE_ID = "{{tokenExchangeId}}";
export const TOKEN_HOSTNAME_ENV = ".{{env}}.";
export const TOKEN_INBOX_DOCUMENT_ID = "{{docId}}";
export const TOKEN_INBOX_TAX_SUMMARY_ID = "{{taxSummaryId}}";